import { render } from "./InventoryStoreView.vue?vue&type=template&id=123850bc&scoped=true"
import script from "./InventoryStoreView.vue?vue&type=script&lang=js"
export * from "./InventoryStoreView.vue?vue&type=script&lang=js"

import "./InventoryStoreView.vue?vue&type=style&index=0&id=123850bc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-123850bc"]])

export default __exports__